import { AxiosInstance, AxiosResponse } from 'axios';
import {
  CreateExpenseRequest,
  Expense,
  ExpenseSearchParams,
  PaginatedResponse,
  UpdateExpenseRequest,
} from '../../types';

export class ExpenseApi {
  constructor(private readonly http: AxiosInstance) {}

  async getExpenses(params: ExpenseSearchParams, signal?: AbortSignal): Promise<PaginatedResponse<Expense>> {
    const requestConfig = signal ? { params, signal } : { params };
    const response: AxiosResponse<PaginatedResponse<Expense>> = await this.http.get('/expenses', requestConfig);
    return response.data;
  }

  async createExpense(request: CreateExpenseRequest): Promise<Expense> {
    const response: AxiosResponse<Expense> = await this.http.post('/expenses', request);
    return response.data;
  }

  async updateExpense(id: string, request: UpdateExpenseRequest): Promise<Expense> {
    const response: AxiosResponse<Expense> = await this.http.put(`/expenses/${id}`, request);
    return response.data;
  }

  async deleteExpense(id: string): Promise<void> {
    await this.http.delete(`/expenses/${id}`);
  }
}
